export default {
    exportName: 'AdminConsoleInfo',
    content: () => import('@/Fwamework/DataImport/Components/FailedImportFilesConsoleComponent.vue'),
    contentData: {
        key: 'FailedImportFilesConsole',
        visible: true
    }
};